import {Skeleton} from '@gwc/core'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import React, {memo} from 'react'

import {FloatingBox, StickyTo} from '../../../FloatingBox'
import * as classes from './ActionButtonSkeleton.classes'

export const ActionButtonSkeleton = memo(
  (): React.ReactElement => (
    <FloatingBox height={spacing(9)} stickyTo={StickyTo.BLOCK_END}>
      <div className={classes.wrapper}>
        <Skeleton className={classes.actionButton} />
      </div>
    </FloatingBox>
  ),
)
